import axios from '@/config/httpConfig'

// 获取小程序、网站设置个案报修单所有人列表
export function getUserList(data) {
  return axios.post('/case/getUserList', data)
}
